var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstragram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.06,
    height: 26.09,
    viewBox: "0 0 26.06 26.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #7b7cd5;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instragram.svg",
    className: "cls-1",
    d: "M1294.16,8942.85a1.53,1.53,0,1,0,1.53,1.53A1.524,1.524,0,0,0,1294.16,8942.85Zm-6.8,1.96a6.425,6.425,0,1,0,6.42,6.42A6.436,6.436,0,0,0,1287.36,8944.81Zm0,10.54a4.115,4.115,0,1,1,4.11-4.12A4.127,4.127,0,0,1,1287.36,8955.35Zm5.1,8.93h-10.42a7.844,7.844,0,0,1-7.83-7.84v-10.42a7.836,7.836,0,0,1,7.83-7.83h10.42a7.836,7.836,0,0,1,7.83,7.83v10.42A7.844,7.844,0,0,1,1292.46,8964.28Zm-10.42-23.64a5.4,5.4,0,0,0-5.38,5.38v10.42a5.388,5.388,0,0,0,5.38,5.38h10.42a5.382,5.382,0,0,0,5.38-5.38v-10.42a5.388,5.388,0,0,0-5.38-5.38h-10.42Z",
    transform: "translate(-1274.22 -8938.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstragram);
export default __webpack_public_path__ + "static/media/instragram.b8a642f42991ac3143ed49310fbe7c5a.svg";
export { ForwardRef as ReactComponent };